module.exports = __webpack_public_path__ + "static/media/Wordmark_white-02.708798ed.svg";